// List of months
export const months = [
    { value: '01', label: 'Jan' },
    { value: '02', label: 'Feb' },
    { value: '03', label: 'Mar' },
    { value: '04', label: 'Apr' },
    { value: '05', label: 'May' },
    { value: '06', label: 'Jun' },
    { value: '07', label: 'Jul' },
    { value: '08', label: 'Aug' },
    { value: '09', label: 'Sep' },
    { value: '10', label: 'Oct' },
    { value: '11', label: 'Nov' },
    { value: '12', label: 'Dec' },
];

// List of years for term , preterm , abortion -> 1960 
export const years = Array.from({ length: new Date().getFullYear() - 1960 + 1 }, (_, index) => 1960 + index).sort((b, a) => a - b);;

// List of weeks in pre term
export const preTermWeeks = Array.from({ length: 36 - 12 + 1 }, (_, index) => 12 + index);

export const abortionWeeks = Array.from({ length: 25 }, (_, index) => index);

export const termWeeks = Array.from({ length: 4 }, (_, index) => 37 + index);

export const interPregnancyYears = Array.from({ length: 60 }, (_, index) => 1 + index);

export const interPregnancyMonths = Array.from({ length: 13 }, (_, index) => index);
